import { Component, ComponentFactoryResolver, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { E2eBean } from 'app/com/ibm/tw/commons/beans/e2e.bean';
import { AdvertisementPositionType } from 'app/com/ibm/tw/commons/enums/area/common/advertisement.position.type';
import { LoginStateType } from 'app/com/ibm/tw/commons/enums/area/common/login.state.type';
import { AreaType } from 'app/com/ibm/tw/commons/enums/global/area.type';
import { B2cLoginComponent } from 'app/com/ibm/tw/commons/mvc';
import { ErrorStatus } from 'app/com/ibm/tw/commons/status/error.status';
import { E2eUtils } from 'app/com/ibm/tw/commons/utils/e2e.utils';
import { StringUtils } from 'app/com/ibm/tw/commons/utils/string.utils';
import { Utils } from 'app/com/ibm/tw/commons/utils/utils';
import { GwFieldValidateResult } from 'app/com/ibm/tw/commons/validate/gw.field.validate.result';
import { GwPageValidator } from 'app/com/ibm/tw/commons/validate/gwpagevalidator';
import { PageFooterComponent } from 'app/pagecode/commonpage/pagefooter/page.footer.component';
import { environment } from 'environments/environment';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { Combo, HttpService, StatusService } from 'ui-components/common';
import { DomHandler } from 'ui-components/dom';
import { ShareService } from '../../../../services';
import { CcmotlgacService } from './../ccmotlgac.service';
import { CcmotlgacHomeViewForm } from './ccmotlgac.home.viewform';
import { CcmotlgacLabeltBean } from './ccmotlgac.label.bean';

declare var jQuery: any;

@Component({
    standalone: false,
    selector: 'ccmotlgac-home-component',
    templateUrl: 'ccmotlgac.home.component.html'
})
export class CcmotlgacHomeComponent extends B2cLoginComponent<CcmotlgacHomeViewForm> implements OnDestroy {

    /** 預設的背景圖 */
    public defaultBackGround: string = '../../../../../inc/img/notice/notice1440x735_01.jpg';

    public defaultPosition: string = AdvertisementPositionType.RIGHT_BOTTOM;

    /** 畫面寬度. */
    public myWidth: number;

    public resizeObservable$: Observable<Event>;

    public resizeSubscription$: Subscription;

    public redirectTimer: any;

    public disabledInput: boolean = true;

    public disabledLoginUserIxd: boolean = true;

    public labeltBean: CcmotlgacLabeltBean;

    public areaType: AreaType = AreaType.GLOBAL;

    @ViewChild('pinText')
    public pinText: ElementRef;

    /** 國別. */
    public countryCombo: Combo;

    /** 使用密碼欄位顯示做用者id. */
    public displayPxssForLoginIxd: boolean = false;

    /** 使用文字型態欄位. */
    public loginUserIxdtxt: string;

    /** 使用密碼型態欄位 */
    public loginUserIxdPin: string;

    @ViewChild('inputLoginIxd')
    public inputLoginIxd: ElementRef;

    @ViewChild('pageFooter')
    public pageFooter: PageFooterComponent;

    /**
     * 建構子
     */
    constructor(public ccmotlgacService: CcmotlgacService, public statusService: StatusService,
        public http: HttpService, public router: Router, public shareService: ShareService,
        public componentFactoryResolver: ComponentFactoryResolver,
        protected domHandler: DomHandler, private route: ActivatedRoute
    ) {
        super(ccmotlgacService);

        if (environment.ssl) {
            let urlValue = window.top.location.href;
            if (urlValue.indexOf('https:') === -1) {
                window.top.location.href = 'https://' + urlValue.substring(urlValue.indexOf('://') + 3);
            }
        }

        let url = window.top.location.href.toLocaleLowerCase();
        console.log('home:' + url);

        this.http.server = environment.twServer;
        this.shareService.currentArea = this.areaType;
        this.shareService.needCheckToken = false;
        this.displayPxssForLoginIxd = false;

        this.labeltBean = new CcmotlgacLabeltBean(this.ccmotlgacService);

        this.initLoginPage();
    }

    private initLoginPage(): void {

        if (this.viewForm === undefined || this.viewForm == null) {

            let viewForm = new CcmotlgacHomeViewForm();
            viewForm.basePath = 'pagecode.cot.ccmotlgac';
            viewForm.navigatePage = 'ccmotlgachome';
            viewForm.areaType = AreaType.GLOBAL;

            let kxy = this.getViewFormKxy();
            this.txnService.setAppParam(kxy, viewForm);
            this.viewForm = viewForm;

            this.doInitViewFormQuery();
        }

    }

    /** 初始化Login Component */
    protected initViewForm(): void {

        console.debug('initViewForm');

        this.initLoginPage();

        this.ccmotlgacService.getAxthenticationService().isInitPage = true;

        this.viewForm.basePath = 'pagecode.cot.ccmotlgac';

        this.reloadCaptcha(true);

        this.viewForm.loginPinValue = '';
        this.viewForm.loginUserIxd = '';
        this.loginUserIxdPin = '';
        this.loginUserIxdtxt = '';

        this.resizeObservable$ = fromEvent(window, 'resize')
        this.resizeSubscription$ = this.resizeObservable$.subscribe(evt => { this.manySize() });
        this.subscriptions.push(this.resizeSubscription$);

        if (innerWidth < 1024 && innerWidth > 767) {
            this.myWidth = 1024;
        } else {
            this.myWidth = innerWidth;
        }

    }

    /** 進行登入. */
    public doLogin(): boolean {

        this.viewForm.basePath = 'pagecode.cot.ccmotlgac';

        this.cleanMessage();

        console.log('(this.displayPxssForLoginIxd:' + this.displayPxssForLoginIxd);
        if (this.displayPxssForLoginIxd) {
            //console.log('his.loginUserIxdPin:' + this.loginUserIxdPin);
            this.viewForm.loginUserIxd = this.loginUserIxdPin;
        } else {
            // console.log('his.loginUserIxdtxt:' + this.loginUserIxdtxt);
            this.viewForm.loginUserIxd = this.loginUserIxdtxt;
        }

        // GIB-81 GIB登出入 出現「請輸入使用者名稱」錯誤訊息
        if (this.viewForm.loginUserIxd === '') {
            this.viewForm.loginUserIxd = jQuery('#inputLoginIxd').val();
        }

        // console.log('query value: ' + jQuery('#inputLoginIxd').val());
        // console.log(' this.viewForm.loginUserIxd:' + this.viewForm.loginUserIxd);

        if (!this.validateAccount(this.viewForm)) {
            return false;
        }

        console.log('loginIxd=' + this.viewForm.loginIxd);

        this.ccmotlgacService.validateAccount(this.viewForm.loginIxd);

        this.maskPage();

        clearTimeout(this.redirectTimer);

        // 重新算出時間因子
        this.viewForm.e2eBean.renewTimeFactor();

        E2eUtils.encryptPin(this.viewForm.e2eBean, this.viewForm.loginPinValue);

        this.viewForm.loginPin = this.viewForm.e2eBean.pin;
        this.viewForm.loginPinLength = this.viewForm.e2eBean.pinLength;
        this.viewForm.operationLog = this.viewForm.e2eBean.getOperationLog();

        this.viewForm.loginPinValue = '';

        // 成功回呼方法
        let succCall = (result: CcmotlgacHomeViewForm) => {

            clearTimeout(this.redirectTimer);

            // 將密碼欄位值清空.
            this.viewForm.loginIxd = '';
            this.viewForm.loginUserIxd = '';
            this.loginUserIxdPin = '';
            this.loginUserIxdtxt = '';
            this.viewForm.captchaAnswer = '';
            this.viewForm.loginPin = '';
            this.viewForm.loginPinLength = '-1';

            this.shareService.setLanguageOptions(result.languageOptions);

            window.top.location.href = result.redirectUrl;
        }

        // 失敗回呼方法
        let errorCall = (result: CcmotlgacHomeViewForm) => {
            // 將密碼欄位值清空.
            if (!this.disabledLoginUserIxd) {
                this.loginUserIxdPin = '';
                this.loginUserIxdtxt = '';
                this.viewForm.loginUserIxd = '';
            }

            this.viewForm.captchaAnswer = '';
            this.viewForm.loginPin = '';
            this.viewForm.loginPinLength = '-1';
            this.errorCallBack(result);

        }

        this.doPostAction(this.viewForm, new CcmotlgacHomeViewForm(), succCall, errorCall, 'doLoginAction');
    }

    /** 更新目前頁面的所有資訊. */
    private setRedirectTimer(redirectUrl: string): void {

        clearTimeout(this.redirectTimer);

        this.redirectTimer = setTimeout(() => {
            this.doInitViewFormQuery.bind(this);
            if (redirectUrl) {
                window.top.location.href = redirectUrl;
            }
        }, this.viewForm.loginSessionPeriod);

    }

    /**
     * 重新產生圖型驗證碼
     * @param event click事件
     * @param cleanPin 是否清除密碼
     */
    public clickReloadCaptcha(event: Event, cleanPin: boolean): void {
        event.preventDefault();
        this.reloadCaptcha(cleanPin);
    }

    /** 產生圖形驗證碼. */
    public reloadCaptcha(cleanPin: boolean): void {

        this.viewForm.serverUrl = this.http.server + '/ccmotlginhome/captcha?seq=' + Math.random();
        this.viewForm.captchaAnswer = '';

        // 將密碼欄位值清空.
        if (cleanPin) {
            this.viewForm.loginPin = '';
            this.viewForm.loginPinLength = '-1';
        }

    }

    /** 查詢首頁的資訊 */
    private doInitViewFormQuery(): void {
        console.log('doInitViewFormQuery start');

        this.maskPage();

        if (this.viewForm === undefined) {
            return;
        }

        this.viewForm.basePath = 'pagecode.cot.ccmotlgac';
        this.viewForm.navigatePage = 'ccmotlgachome';

        const hash = window.location.hash;
        const urlParams = new URLSearchParams(hash.split('?')[1]);
        this.viewForm.accessToken = urlParams.get('accessToken');

        // 當前URL調整(僅保留host)
        let currentUrl = window.top.location.origin;
        if (environment.ssl) {
            currentUrl = 'https://' + window.top.location.host;
        }
        window.history.pushState({}, null, currentUrl);

        // 成功回呼方法
        let succCall = (viewForm: CcmotlgacHomeViewForm) => {
            this.unMaskPage();

            if (viewForm.gwPageValidator !== undefined) {
                super.showPageError(viewForm.gwPageValidator);
            }

            this.viewForm.loginUserIxdMaxLength = viewForm.loginUserIxdMaxLength;
            this.viewForm.loginUserIxd = viewForm.loginUserIxd;
            this.loginUserIxdtxt = viewForm.loginUserIxd;
            this.disabledLoginUserIxd = StringUtils.isNotBlank(viewForm.loginUserIxd);

            this.viewForm.loginIxdMaxLength = viewForm.loginIxdMaxLength;
            this.viewForm.loginIxd = viewForm.loginIxd;

            this.shareService.httpToken = viewForm.httpToken;
            this.txnService.getShareService().replaceTokenFrom.push('TimeStamp: ' + Utils.generateTimeStamp() + ' doInitViewFormQuery & succCall :' + viewForm.httpToken);

            if (this.viewForm.e2eBean === undefined && !(viewForm.e2eBean === undefined)) {
                this.viewForm.e2eBean = new E2eBean();
                this.viewForm.e2eBean.timeFactorValue = viewForm.e2eBean.timeFactorValue;
                this.viewForm.e2eBean.timeFactor = viewForm.e2eBean.timeFactor;
                this.viewForm.e2eBean.systemFlag = viewForm.e2eBean.systemFlag;
                this.viewForm.e2eBean.publicKxy = viewForm.e2eBean.publicKxy;

                this.viewForm.e2eBean.init();
            }

            this.viewForm.language = viewForm.language;
            this.viewForm.selectedLocale = viewForm.selectedLocale;
            this.viewForm.loginSessionPeriod = viewForm.loginSessionPeriod;
            this.viewForm.enablePinKeyboard = viewForm.enablePinKeyboard;

            this.shareService.setLanguageOptions(viewForm.languageOptions);
            this.shareService.rsaKxy = viewForm.rsaKxy;
            this.shareService.enableE2e = viewForm.enableE2e;

            this.http.rsaKxy = viewForm.rsaKxy;

            this.disabledInput = false;
            this.countryCombo = viewForm.countryCombo;
            this.viewForm.areaType = this.areaType;

            // 直接轉導
            if (viewForm.redirect) {
                window.top.location.href = viewForm.redirectUrl;
            } else {
                this.setRedirectTimer(viewForm.redirectUrl);
            }

        }

        // 失敗回呼方法
        let errorCall = (error: ErrorStatus) => {
            // 轉導錯誤頁面
            super.goToErrorPage(error);
        }

        this.viewForm.selectedLocale = this.txnService.getLocaleStorageValue();
        this.txnService.setCurrentLangJson(this.viewForm.selectedLocale, this.changePageLabel.bind(this));

        super.doPostAction(this.viewForm, new CcmotlgacHomeViewForm(), succCall, errorCall, 'initLoginPage');
    }

    private changePageLabel() {
        this.labeltBean = new CcmotlgacLabeltBean(this.ccmotlgacService);
    }

    /** 將表單重設 */
    resetForm() {
        if (!this.disabledLoginUserIxd) {
            this.loginUserIxdPin = '';
            this.loginUserIxdtxt = '';
        }
        this.viewForm.loginPinValue = '';
        this.viewForm.captchaAnswer = '';
        this.viewForm.displayCaptchaAnswerMessage = false;
        this.viewForm.displayLoginPinMessage = false;
        this.viewForm.displayLoginUserIxdMessage = false;
        this.viewForm.displayLoginIxdMessage = false;
    }

    /** Error處理 */
    private errorCallBack(viewForm: CcmotlgacHomeViewForm): void {
        // 停留在原頁
        if (this.viewForm.navigatePage === viewForm.navigatePage) {
            this.unMaskPage();
            this.reloadCaptcha(true);
            this.displayValidateResult(viewForm.gwPageValidator);
        } else {
            window.top.location.href = viewForm.redirectUrl;
        }
    }

    /** 清除畫面中的錯誤訊息 */
    private cleanMessage(): void {
        this.viewForm.loginIxdMessage = '';
        this.viewForm.displayLoginIxdMessage = false;
        this.viewForm.loginUserIxdMessage = '';
        this.viewForm.displayLoginUserIxdMessage = false;
        this.viewForm.loginPinMessage = '';
        this.viewForm.displayLoginPinMessage = false;
        this.viewForm.captchaAnswerMessage = '';
        this.viewForm.displayCaptchaAnswerMessage = false;
        this.viewForm.loginStateType = LoginStateType.UNKNOWN;
    }

    /** 顯示檢核訊息. */
    private displayValidateResult(gwPageValidator: GwPageValidator): void {

        if (gwPageValidator.fields.length > 0) {
            let gwFieldValidateResult: GwFieldValidateResult = gwPageValidator.fields[0];

            if (gwFieldValidateResult.fieldIxd === 'loginIxd') {
                this.viewForm.loginIxdMessage = gwFieldValidateResult.displayErrorDesc;
                this.viewForm.displayLoginIxdMessage = true;
            } else if (gwFieldValidateResult.fieldIxd === 'loginUserIxd') {
                this.viewForm.loginUserIxdMessage = gwFieldValidateResult.displayErrorDesc;
                this.viewForm.displayLoginUserIxdMessage = true;
            } else if (gwFieldValidateResult.fieldIxd === 'loginPin') {
                this.viewForm.loginPinMessage = gwFieldValidateResult.displayErrorDesc;
                this.viewForm.displayLoginPinMessage = true;
            } else if (gwFieldValidateResult.fieldIxd === 'captchaAnswer') {
                this.viewForm.captchaAnswerMessage = gwFieldValidateResult.displayErrorDesc;
                this.viewForm.displayCaptchaAnswerMessage = true;
            }
        }

    }

    /** 確認表單中的欄位是否都有輸入 */
    private validateAccount(viewForm: CcmotlgacHomeViewForm): boolean {

        if (StringUtils.isBlank(viewForm.loginIxd)) {
            viewForm.displayLoginIxdMessage = true;
            viewForm.loginIxdMessage = this.txnService.transform('請輸入顧客ID', 'cot00003139', null);
            return false;
        }
        this.viewForm.loginIxd = this.viewForm.loginIxd.toUpperCase();

        if (this.checkMaxLength(viewForm.loginIxd, viewForm.loginIxdMaxLength)) {
            viewForm.displayLoginIxdMessage = true;
            viewForm.loginIxdMessage = this.txnService.transform('顧客ID長度過長', 'cot00005736', null);
            return false;
        }

        if (StringUtils.isBlank(viewForm.loginUserIxd)) {
            viewForm.displayLoginUserIxdMessage = true;
            viewForm.loginUserIxdMessage = this.txnService.transform('請輸入使用者名稱', 'cot00001362', null);
            return false;
        }

        if (this.checkMaxLength(viewForm.loginUserIxd, viewForm.loginUserIxdMaxLength)) {
            viewForm.displayLoginUserIxdMessage = true;
            viewForm.loginUserIxdMessage = this.txnService.transform('使用者名稱過長', 'cot00004845', null);
            return false;
        }

        if (StringUtils.isBlank(viewForm.loginPinValue)) {
            viewForm.displayLoginPinMessage = true;
            viewForm.loginPinMessage = this.txnService.transform('請輸入使用者密碼', 'cot00001505', null);
            return false;
        }

        if (StringUtils.isBlank(viewForm.captchaAnswer)) {
            viewForm.displayCaptchaAnswerMessage = true;
            viewForm.captchaAnswerMessage = this.txnService.transform('請輸入驗證碼', 'cot00001207', null);
            return false;
        }

        this.viewForm.illegalPin = false;

        return true;
    }

    /** ID長度檢核 */
    private checkMaxLength(elmValue: string, maxlength: number): boolean {
        let escapedStr = encodeURI(elmValue);
        let count: number = 0;

        if (escapedStr.indexOf('%') !== -1) {
            count = escapedStr.split('%').length - 1;

            if (count === 0) {
                count++  // perverse case; can't happen with real UTF-8
            }
            let tmp = escapedStr.length - (count * 3);

            count = count + tmp;
        } else {
            count = escapedStr.length;
        }

        return (count > maxlength);
    }

    public onPinKeydown(event): void {
        if (event.which === 13) {
            this.doLogin();
        }
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        clearTimeout(this.redirectTimer);
        this.resizeSubscription$.unsubscribe();
    }

    /** 使用者名稱遮罩 */
    public clickEyeIcon(): void {

        let nativeEyeIcon = document.getElementById('eyeIcon') as HTMLInputElement;

        if (nativeEyeIcon.classList.contains('fa-eye-slash')) {
            // 顯示原始欄位
            this.domHandler.removeClass(nativeEyeIcon, 'fa-eye-slash');
            this.domHandler.addClass(nativeEyeIcon, 'fa-eye');
            this.inputLoginIxd.nativeElement.type = 'text';
        } else if (nativeEyeIcon.classList.contains('fa-eye')) {
            // 隱藏原始欄位
            this.domHandler.removeClass(nativeEyeIcon, 'fa-eye');
            this.domHandler.addClass(nativeEyeIcon, 'fa-eye-slash');
            this.inputLoginIxd.nativeElement.type = 'password';
        }
    }

    private manySize(): void {
        if (innerWidth < 1024 && innerWidth > 767) {
            this.myWidth = 1024;
        } else {
            this.myWidth = innerWidth;
        }
    }

    /** GIB-8979 點擊顧客ID or 密碼EyeIcon. */
    public clickLoginIxdPinEyeIcon(ixd: string) {

        let eyeIcon = document.getElementById(ixd + 'EyeIcon') as HTMLInputElement;
        let inputText = document.getElementById(ixd + 'Text') as HTMLInputElement;

        if (eyeIcon.classList.contains('fa-eye-slash')) {
            // 顯示
            this.domHandler.removeClass(eyeIcon, 'fa-eye-slash');
            this.domHandler.addClass(eyeIcon, 'fa-eye');
            inputText.type = 'text';
        } else if (eyeIcon.classList.contains('fa-eye')) {
            // 隱藏
            this.domHandler.removeClass(eyeIcon, 'fa-eye');
            this.domHandler.addClass(eyeIcon, 'fa-eye-slash');
            inputText.type = 'password';
        }
    }
}
